import { ClientEntity } from './ClientEntity'

export class ClientPortal extends ClientEntity {
  static type = 'portal'

  init() {
    this._sprite = this.world.sprites.add({
      x: this.data.position.x,
      y: this.data.position.y,
      yBase: this.data.position.yBase,
      url: this.data.sprite.url,
      width: this.data.sprite.width,
      height: this.data.sprite.height,
      fps: this.data.sprite.fps,
    })
    this._shadow = this.world.shadows.add({
      x: this.data.position.x,
      y: this.data.position.y,
      url: this.data.shadow.url,
      width: this.data.sprite.width,
      height: this.data.sprite.height,
    })
    this._target = this.world.targets.add({
      px: this.data.position.x,
      py: this.data.position.y,
      ox: this.data.target.ox,
      oy: this.data.target.oy,
      radius: this.data.target.radius,
      value: this,
    })
  }

  onChange(changes) {
    if (changes.position) {
      this._sprite?.setPosition(this.data.position.x, this.data.position.y)
      this._shadow?.setPosition(this.data.position.x, this.data.position.y)
      this._target?.setPosition(this.data.position.x, this.data.position.y)
    }
  }

  destroy() {
    this._sprite?.destroy()
    this._shadow?.destroy()
    this._target?.destroy()
    super.destroy()
  }
}
